import { Card, CardProps } from 'antd';
import { ContainerCard } from './styles';

interface ICardProps extends CardProps {
  children: React.ReactNode | string;
}

export const ACard: React.FC<ICardProps> = ({ children, ...res }) => {
  return (
    <ContainerCard>
      <Card {...res}>{children}</Card>
    </ContainerCard>
  );
};
